/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dictation_StopInputs */

const en_dictation_stop = /** @type {(inputs: Dictation_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop dictating`)
};

const pt_br2_dictation_stop = /** @type {(inputs: Dictation_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parar ditado`)
};

/**
* | output |
* | --- |
* | "Stop dictating" |
*
* @param {Dictation_StopInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dictation_stop = /** @type {((inputs?: Dictation_StopInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dictation_StopInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dictation_stop(inputs)
	return pt_br2_dictation_stop(inputs)
});